
const digest = '3a75c84e17054bf55d09465abaae6123f330e4d6226513c88b04a60d6302c933';
const css = `._toolbar_1bs5w_1 {
  border-radius: var(--aha-editor-v2--border-radius)
    var(--aha-editor-v2--border-radius) 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
  background-color: var(--theme-editor-toolbar);
  position: relative;
  padding: 3px;
}

._elementToolbarButton_1bs5w_13 svg {
  pointer-events: none;
}

/* Don't change toolbar in fullscreen. Seems unnecessary now toolbar is bigger.
.toolbar.fullScreen {
  visibility: visible !important;
  margin: 0 !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--aha-blue-200);

  .toolbarButton {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
    line-height: 1.5;
  }
}
*/

._toolbarItems_1bs5w_34 {
  display: flex;
  align-items: center;
  gap: 1px;
  opacity: 1;
  transition: opacity 0.2s;
}

._faded_1bs5w_42 {
  opacity: 0;
  transition: opacity 0s;
}

._toolbarSection_1bs5w_47 {
  display: flex;
  flex-direction: row;
}

._toolbarButton_1bs5w_24,
._toolbarItem_1bs5w_34 {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--editor-v2-toolbar-button-color);
  border-radius: var(--editor-v2-toolbar-button-radius);
  font-size: var(--editor-v2-toolbar-button-font-size);
  height: var(--editor-v2-toolbar-button-size);
  min-width: var(--editor-v2-toolbar-button-size);
  font-weight: 400;
  line-height: var(--editor-v2-toolbar-button-font-size);
  padding: 2px 5px;
  margin: 1px;
}

._hideCaret_1bs5w_69::after {
  display: none;
}

._toolHDivider_1bs5w_73 {
  border-right: 1px solid var(--theme-secondary-border);
  margin: 4px 5px;
}

._toolbarButton_1bs5w_24 .fa-caret-down {
  margin-left: 0.3rem;
}

._toolbarButton_1bs5w_24:hover,
._toolbarItem_1bs5w_34:hover {
  background-color: var(--theme-editor-button-hovered);
  color: var(--aha-gray-900);
}

._toolbarButton_1bs5w_24:active,
._toolbarItem_1bs5w_34:active,
aha-menu[open] > ._toolbarButton_1bs5w_24,
aha-menu[open] > ._toolbarItem_1bs5w_34 {
  color: var(--aha-blue-700);
  background-color: var(--aha-blue-300);
}

._toolbarButton_1bs5w_24[aria-disabled='true'],
._toolbarItem_1bs5w_34[aria-disabled='true'] {
  opacity: 0.3;
  pointer-events: none;
}

._toolbarButton_1bs5w_24[aria-selected='true'],
._toolbarItem_1bs5w_34[aria-selected='true'] {
  color: var(--aha-blue-700);
  background-color: var(--theme-editor-button-active);
}

._toolbarButtonText_1bs5w_108 {
  font-size: 12px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* We need to override all styles so we override the bootstrap form.less styles
 * that are applied to all inputs. */
._toolbarInput_1bs5w_118 {
  width: 200px;
  border: none;
  padding: 3px !important;
  margin: 0 !important;
  border-radius: var(--Common--border-radius) !important;
  box-shadow: none !important;
}
._toolbarInput_1bs5w_118:focus {
  outline: 2px solid var(--aha-blue-400) !important;
  box-shadow: none !important;
}

._hintToolShortcut_1bs5w_131 {
  padding: 2px 4px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.2);
}

._cellBackgroundColorIcon_1bs5w_137 {
  width: 14px;
  height: 14px;
  border: 1px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._borderColorIcon_1bs5w_144 {
  display: block;
  width: 12px;
  height: 12px;
  border: 3px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._colorIconNone_1bs5w_152 {
  background: linear-gradient(
    to top right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) calc(50% - 2px),
    rgb(214, 157, 157) 50%,
    rgba(0, 0, 0, 0) calc(50% + 2px),
    rgba(0, 0, 0, 0) 100%
  );
}

._toolbar_1bs5w_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}

._toolbarMenuItem_1bs5w_167 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

._toolbarMenuItemLabel_1bs5w_173 {
  display: flex;
  flex: 1 1;
  gap: var(--spacer-1);
  align-items: center;
}

._toolbarMenuItemShortcut_1bs5w_180 {
  color: var(--theme-light-gray-700-dark-gray-200);
}

._alternateRowColorIcon_1bs5w_184 {
  position: relative;
}

._alternateRowColorCircle_1bs5w_188 {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--theme-primary-background);
}

._alternateRowColorCircleInner_1bs5w_201 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--aha-gray-100);
}
._lineWidthSliderWrapper_1bs5w_207 {
  margin: var(--spacer-2) var(--spacer-3);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"toolbar":"_toolbar_1bs5w_1","elementToolbarButton":"_elementToolbarButton_1bs5w_13","toolbarItems":"_toolbarItems_1bs5w_34","faded":"_faded_1bs5w_42","toolbarSection":"_toolbarSection_1bs5w_47","toolbarButton":"_toolbarButton_1bs5w_24","toolbarItem":"_toolbarItem_1bs5w_34","hideCaret":"_hideCaret_1bs5w_69","toolHDivider":"_toolHDivider_1bs5w_73","toolbarButtonText":"_toolbarButtonText_1bs5w_108","toolbarInput":"_toolbarInput_1bs5w_118","hintToolShortcut":"_hintToolShortcut_1bs5w_131","cellBackgroundColorIcon":"_cellBackgroundColorIcon_1bs5w_137","borderColorIcon":"_borderColorIcon_1bs5w_144","colorIconNone":"_colorIconNone_1bs5w_152","toolbarMenuItem":"_toolbarMenuItem_1bs5w_167","toolbarMenuItemLabel":"_toolbarMenuItemLabel_1bs5w_173","toolbarMenuItemShortcut":"_toolbarMenuItemShortcut_1bs5w_180","alternateRowColorIcon":"_alternateRowColorIcon_1bs5w_184","alternateRowColorCircle":"_alternateRowColorCircle_1bs5w_188","alternateRowColorCircleInner":"_alternateRowColorCircleInner_1bs5w_201","lineWidthSliderWrapper":"_lineWidthSliderWrapper_1bs5w_207"};
export { css, digest };
  